export default __webpack_public_path__ + "9a964093c9f09a8a0eabca2688b3863c.png";